import {http} from './http/request';

const SCRATCH_RESOURCE_PAGE_SIZE = 30;

const normalizeTags = tags => {
    if (Array.isArray(tags)) return tags;
    return String(tags || '')
        .split(',')
        .map(tag => tag.trim())
        .filter(tag => tag);
};

const normalizeResource = item => {
    const dataFormat = item.dataFormat || '';
    const md5ext = item.md5ext || (item.assetId && dataFormat ? `${item.assetId}.${dataFormat}` : '');
    return {
        ...item,
        format: item.format || dataFormat,
        tags: normalizeTags(item.tags),
        md5ext
    };
};

const buildScratchResourceParams = (query, type) => {
    const params = {
        pageIndex: query.pageIndex || 1,
        pageSize: query.pageSize || SCRATCH_RESOURCE_PAGE_SIZE,
        type
    };
    const filterQuery = (query.filterQuery || '').trim();
    const selectedTag = query.selectedTag || 'all';
    if (filterQuery) {
        params.name = filterQuery;
    }
    if (selectedTag !== 'all') {
        params.tags = selectedTag;
    }
    return params;
};

const loadScratchResources = (query, type) => {
    const endpoint = query.sourceScope === 'mine' ?
        '/scratchResource/myPageList' :
        '/scratchResource/pageList';
    return http.get(endpoint, buildScratchResourceParams(query, type))
        .then(response => {
            const result = response.result || {};
            const pageIndex = query.pageIndex || 1;
            const pageSize = query.pageSize || SCRATCH_RESOURCE_PAGE_SIZE;
            const records = (result.records || []).map(normalizeResource);
            const pages = Number(result.pages);
            const total = Number(result.total);
            const hasMore = pages ?
                pageIndex < pages :
                (total ? pageIndex * pageSize < total : records.length >= pageSize);

            return {
                hasMore,
                records,
                response
            };
        });
};

const loadRandomScratchResource = type => (
    http.get(`/scratchResource/random/${type}`)
        .then(response => {
            if (response && response.success === false) {
                throw new Error(response.message || 'Scratch resource random load failed');
            }
            if (!response || !response.result) {
                throw new Error('Scratch resource random load failed');
            }
            return normalizeResource(response.result);
        })
);

export {
    SCRATCH_RESOURCE_PAGE_SIZE,
    loadRandomScratchResource,
    loadScratchResources
};
